import { Component, OnInit, ViewEncapsulation, AfterViewInit, HostListener, ElementRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BigNumber } from "ethers";
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { switchMap, takeWhile, timer } from 'rxjs';
import { v4 as uuidv4 } from 'uuid';
import { ONRAMPER_QUERY_PARAM, convertJSONToQueryParam } from 'app/common/components/onramper/onramper.config';
import { ToastService } from 'app/services/toast-wrapper/toast-wrapper.service';
import { UserService } from 'app/services/user/user.service';
import { Web3Service } from 'app/services/web3/web3.service';
import { ContractsService } from 'app/services/contract/contracts.service';
import { environment } from 'environments/environment';
import { eContracts } from 'app/services/contract/contract.config';
declare const window
declare const Simplex
@Component({
    selector: 'app-kmon',
    templateUrl: './kmon.component.html',
    styleUrls: ['./kmon.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class KmonComponent implements OnInit, AfterViewInit {

    public kmonBalanceInit
    public bnbBalanceInit
    // public account
    public cardExtend: any = [false, false]
    public isLoading: any = [false, false]
    public successTx: any = [false, false]
    public kmonWallet
    public kmonAmount
    public bnbWallet
    public bnbAmount
    public addressValidKmon
    public addressValidBnb
    public purchaseBoxes: any = []
    public boxSelected: any = [false, false, false]
    public parsedBoxes
    public amountSelected
    public kmonAmountSelected
    public isSimplexLoading: any = [false, false, false]
    public isSimplexSuccess: any = [false, false, false]
    public showWidget
    public waitingForFunds
    public simulateSuccess
    public kmonBalanceInitFormatted
    public bnbBalanceInitFormatted
    public hasKmonAllowance
    public hasNFTAllowance
    public hasBiddingAllowance
    public hasLootboxesAllowance
    public hasBreedingAllowance
    public loadingAllowances: any = [false, false, false, false, false]
    public walletTransactions: any = []
    public isLonger
    showOnramper: boolean = false;
    onramperQueryParam: { [key: string]: string } = ONRAMPER_QUERY_PARAM();
    onramperQUeryParamString: string;
    srcOnramper: SafeResourceUrl;
    partnerContext: string;
    indexCard: number;
    bnbAmountToConvert: number;
    wallet: string;
    web3: any;
    constructor(
        private http: HttpClient,
        private sanitizer: DomSanitizer,
        private eRef: ElementRef,
        private toastService: ToastService,
        private userService: UserService,
        private web3Service: Web3Service,
        private contractsService: ContractsService
    ) {

        this.addressValidKmon = false;
        this.addressValidBnb = false;
        this.parsedBoxes = false;
        this.showWidget = false;
        this.waitingForFunds = false;
        this.simulateSuccess = false;
        this.isLonger = false;


        // if (this.appComponent.accounts == undefined) {
        //     this.appComponent.accountsObservable.subscribe((item: any) => {
        //         this.wallet = item[0];
        //         this.getKmonBalance()
        //         this.getBnbBalance()
        //         this.checkAllAllowance()
        //         this.getWalletTransactions();
        //         this.checkPendingTx();

        //     });
        // } else {
        // this.wallet = this.appComponent.accounts[0];
        this.wallet = this.userService._userInfoData.recordedWallet;
        this.web3 = this.web3Service.getWeb3();
        this.getKmonBalance()
        this.getBnbBalance()
        this.checkAllAllowance()
        this.getWalletTransactions();
        this.checkPendingTx();

        // }

        this.http.get(environment.coingecko + "api/v3/simple/price?ids=kryptomon,wbnb&vs_currencies=bnb,usd&precision=18").subscribe((item: any) => {
            console.log(item)
            let kmonPrice = item.kryptomon.usd;
            let bnbAmount = 5 / item.wbnb.usd;
            this.createBuyingBoxesRefill(kmonPrice, bnbAmount)
        })

    }

    ngOnInit(): void {
        // this.partnerContext = uuidv4();
    }

    ngAfterViewInit(): void {
    }

    checkPendingTx() {
        let post = { walletId: this.wallet };
        this.http.post(environment.apiBaseUrl + "simplex/getPendingTx.php", post).subscribe((item: any) => {
            console.log(item)
            if (item.status) {
                this.isLonger = true;
            } else {
                this.isLonger = false;
            }
        })
    }

    async getKmonBalance() {
        const balance = await this.contractsService.getContract(eContracts.KMON).methods.balanceOf(this.wallet).call();
        this.kmonBalanceInit = await parseFloat(this.web3.utils.fromWei(balance))
        this.kmonBalanceInitFormatted = (Math.round(this.kmonBalanceInit * 1000) / 1000).toLocaleString()

    }

    async getBnbBalance() {
        const balanceBnb = await this.web3.eth.getBalance(this.wallet);
        this.bnbBalanceInit = await parseFloat(this.web3.utils.fromWei(balanceBnb))
        this.bnbBalanceInitFormatted = (Math.round(this.bnbBalanceInit * 1000) / 1000).toLocaleString()
        console.log(this.bnbBalanceInit)
    }

    isValidAddressKmon() {
        this.addressValidKmon = this.web3.utils.isAddress(this.kmonWallet);
    }

    isValidAddressBnb() {
        this.addressValidBnb = this.web3.utils.isAddress(this.bnbWallet);
    }

    async sendKmon() {
        this.isLoading[0] = true;
        let kmonAmountToSend = this.web3.utils.toWei(this.kmonAmount.toString(), 'ether')
        await this.contractsService.getContract(eContracts.KMON).methods.transfer(this.kmonWallet, kmonAmountToSend).send({
            ...this.contractsService.additionalParameters(),
            from: this.wallet
        }).then((item) => {
            if (item.status) {
                this.isLoading[0] = false;
                this.successTx[0] = true;
                this.getWalletTransactions()
                this.getKmonBalance().then(() => {
                    this.successTx[0] = false;
                });
            } else {
                this.isLoading[0] = false;
                this.toastService.genericError()
            }
        }).catch((err) => {
            this.isLoading[0] = false;
            this.toastService.genericError()
        })
    }

    async sendBnb() {
        this.isLoading[1] = true;
        let bnbToSend = this.web3.utils.toWei(this.bnbAmount.toString(), 'ether')
        console.log(this.web3.eth)
        await this.web3.eth.sendTransaction({
            from: this.wallet,
            to: this.bnbWallet,
            value: bnbToSend,
            ...this.contractsService.additionalParameters(),
        }).then((item) => {
            if (item.status) {
                this.isLoading[1] = false;
                this.successTx[1] = true;
                this.getWalletTransactions()
                this.getBnbBalance().then(() => {
                    this.successTx[1] = false;
                });
            } else {
                this.isLoading[1] = false;
                this.toastService.genericError()
            }
        }).catch((err) => {
            this.isLoading[1] = false;
            this.toastService.genericError()
        })

    }

    createBuyingBoxesRefill(kmonPrice, bnbAmount) {

        for (let i = 0; i < 3; i++) {
            let purchaseBox: any = {}
            purchaseBox.img = "./assets/img/Icon/coins_" + i + ".png";
            purchaseBox.totalValue = Math.round((19.99 + (i * 20)) * 100) / 100;
            console.log(purchaseBox.totalValue)
            purchaseBox.kmonAmount = (Math.round((purchaseBox.totalValue - 5) / kmonPrice * 100) / 100)
            purchaseBox.bnbAmount = (Math.round(bnbAmount * 100) / 100)
            if (purchaseBox.kmonAmount >= 1000) {
                purchaseBox.kmonAmountFormatted = (Math.round(purchaseBox.kmonAmount / 1000 * 100) / 100).toLocaleString() + "K"
            } else {
                purchaseBox.kmonAmountFormatted = (Math.round(purchaseBox.kmonAmount * 100) / 100).toLocaleString()
            }

            this.purchaseBoxes.push(purchaseBox);
        }
        this.boxSelected[0] = false;
        this.parsedBoxes = true;
        //this.amountSelected = this.purchaseBoxes[0].totalValue
        console.log(this.purchaseBoxes)
    }

    initPurchase(index) {
        if (this.wallet) {
            this.partnerContext = uuidv4();
            this.indexCard = index;
            this.isSimplexLoading = [false, false, false];
            this.isSimplexSuccess = [false, false, false];
            for (let i = 0; i < 3; i++) {
                if (i == index) {
                    this.isSimplexLoading[i] = true;
                    this.amountSelected = this.purchaseBoxes[i].totalValue
                    this.kmonAmountSelected = this.purchaseBoxes[i].kmonAmount
                    this.http.get(environment.coingecko + "api/v3/simple/price?ids=kryptomon,wbnb&vs_currencies=bnb,usd&precision=18").subscribe((item: any) => {
                        console.log(item);
                        let bnbAmount = (this.amountSelected - 5) / item.wbnb.usd * 1.05;
                        this.bnbAmountToConvert = bnbAmount;
                        console.log(bnbAmount)
                        console.log(this.bnbBalanceInit)
                        if (this.bnbBalanceInit * 1.10 > bnbAmount) {
                            this.checkAllowance(bnbAmount, i)
                        } else {
                            this.startPurchase(i)
                        }

                    })
                    //
                } else {
                    this.isSimplexLoading[i] = false;
                }
            }
            console.log(this.boxSelected)
        }
    }

    closeSimplex() {
        Simplex.unload();
        this.showWidget = false;
        this.isSimplexLoading = [false, false, false];
    }

    closeOnramper() {
        this.showOnramper = false;
        this.isSimplexLoading = [false, false, false];
        this.checkOnramperTransactionStatus();
    }

    checkOnramperTransactionStatus() {
        const maxAttempts = 20;
        const interval = 6000; // 6 seconds
        let attempts = 0;
        this.isSimplexLoading[this.indexCard] = true;
        timer(0, interval)
            .pipe(
                takeWhile(() => attempts < maxAttempts),
                // https://api-staging-n7ni4.ondigitalocean.app/onramper/status/
                // switchMap(() => this.http.get<any>('http://localhost:5530/onramper/status/' + this.partnerContext))
                switchMap(() => this.http.get<any>('https://stingray-app-4qz4a.ondigitalocean.app/onramper/status/' + this.partnerContext))
            )
            .subscribe(
                response => {
                    if (response.status === 'completed') {
                        console.log('attempts: ' + attempts);
                        //Convert directly
                        this.convertBNBtoKMON(this.bnbAmountToConvert, this.indexCard);
                        this.isSimplexLoading[this.indexCard] = false;
                        attempts = maxAttempts;
                    } else if (response.status === 'pending') {
                        attempts++;
                        console.log(`Attempt ${attempts} - answer: ${response.status}`);
                        this.isSimplexLoading[this.indexCard] = true;
                    } else {
                        this.toastService.genericError();
                        this.isSimplexLoading[this.indexCard] = false;
                    }
                },
                error => {
                    if (error.status === 404) console.error('Transaction not executed:', error);
                    this.isSimplexLoading[this.indexCard] = false;
                }
            );
    }

    getSrcOnramper() {
        // this.onramperQueryParam['defaultAmount'] = '';
        this.onramperQueryParam['defaultAmount'] = this.amountSelected;
        this.onramperQueryParam['networkWallets'] = ONRAMPER_QUERY_PARAM()['networkWallets'];
        this.onramperQueryParam['networkWallets'] += this.wallet;
        this.onramperQueryParam['partnerContext'] = this.partnerContext;
        // console.log(this.onramperQueryParam);
        this.onramperQUeryParamString = convertJSONToQueryParam(this.onramperQueryParam);
        return this.sanitizer.bypassSecurityTrustResourceUrl(
            'https://buy.onramper.com/?' + this.onramperQUeryParamString
        );
    }

    startPurchase(index) {
        this.isSimplexLoading[index] = true;
        let post = { walletId: this.wallet, amount: this.amountSelected }
        console.log(post)
        this.srcOnramper = this.getSrcOnramper();
        this.showOnramper = true;




        //    this.http.post(environment.apiBaseUrl + "simplex/makePurchase.php", post).subscribe(
        //     (item:any)=>{
        //        console.log(item)

        //        if(item.status=="done"){
        //            this.showWidget = true;
        //             const params = {
        //                 payment_id: item.payload.paymentId
        //             }

        //             Simplex.load(params, (event)=> {

        //                 Simplex.subscribe('onlineFlowFinished', (event)=>{
        //                     this.showWidget = false;
        //                     if(event.payload.result=="success"){
        //                         this.checkBnbPurchase(index, 0)
        //                        /* setTimeout(()=>{
        //                             this.simulateSuccess = false
        //                         },10000)*/
        //                     }else{
        //                         Simplex.unload();
        //                         this.isSimplexLoading[index] = false;
        //                         console.log('ops something went wrong')
        //                         this.toastService.genericError()
        //                     }
        //                 })
        //             })
        //        }else{
        //            this.isSimplexLoading[index] = false;
        //            this.toastService.genericError()
        //        }
        //    })
    }

    jumpToConversion() {

    }

    async checkBnbPurchase(index, timer) {
        Simplex.unload();
        const balanceBnb = await this.web3.eth.getBalance(this.wallet);
        let newBnbBalance = await parseFloat(this.web3.utils.fromWei(balanceBnb))
        console.log(newBnbBalance)
        if (newBnbBalance > this.bnbBalanceInit || this.simulateSuccess) {
            let bnbReceived = newBnbBalance - this.bnbBalanceInit;
            this.http.get(environment.coingecko + "api/v3/simple/price?ids=kryptomon,wbnb&vs_currencies=bnb,usd&precision=18").subscribe((item: any) => {
                let amountToConvert = bnbReceived - Math.round(5 / item.wbnb.usd * 100) / 100
                console.log(amountToConvert)
                this.checkAllowance(amountToConvert, index)
            })
        } else {
            if (timer == 60) {
                this.isLonger = true;
            } else {
                setTimeout(() => {
                    timer = timer + 1;
                    this.checkBnbPurchase(index, timer);
                }, 5000)
            }
        }

    }

    async convertBNBtoKMON(bnbAmount, index) {

        this.http.get(environment.coingecko + "api/v3/simple/price?ids=kryptomon,wbnb&vs_currencies=bnb,usd&precision=18").subscribe((item: any) => {
            let minKmonAmount = bnbAmount / item.kryptomon.bnb * 0.80;
            let bnbAmountWei = this.web3.utils.toWei(bnbAmount.toString());
            let minKmonAmountWei = this.web3.utils.toWei(minKmonAmount.toString());
            let path = ["0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c", "0xc732B6586A93b6B7CF5FeD3470808Bc74998224D"]
            let expiry = Math.floor(Date.now() / 1000) + 60 * 10;
            let expireWei = this.web3.utils.toWei(expiry.toString());
            console.log(expireWei)
            this.contractsService.getContract(eContracts.PancakeV2).methods.swapExactETHForTokens(minKmonAmountWei, path, this.wallet, expireWei).send({
                ...this.contractsService.additionalParameters(),
                from: this.wallet,
                value: bnbAmountWei
            }).then((item) => {
                if (item.status) {
                    this.isSimplexLoading[index] = false;
                    this.isSimplexSuccess[index] = true;
                    this.getWalletTransactions()
                    this.getKmonBalance()
                    this.getBnbBalance()
                    setTimeout(() => {
                        this.isSimplexSuccess[index] = false;
                    }, 5000)
                } else {
                    this.isSimplexLoading[index] = false;
                    this.toastService.genericError()
                }
            }).catch((err) => {
                this.isLoading = false;
                this.isSimplexLoading[index] = false;
                this.toastService.genericError()
            })
        }, (err) => {
            this.isLoading = false;
            this.isSimplexLoading[index] = false;
            this.toastService.genericError()
        })

    }

    async checkAllowance(amountToConvert, index) {
        let allowance = await this.contractsService.getContract(eContracts.WBNB).methods.allowance(this.wallet, "0x10ED43C718714eb63d5aA57B78B54704E256024E").call();
        let hasAllowance = BigNumber.from(allowance).gt(0);

        if (hasAllowance) {
            this.convertBNBtoKMON(amountToConvert, index)
        } else {
            this.contractsService.getContract(eContracts.WBNB).methods.approve("0x10ED43C718714eb63d5aA57B78B54704E256024E", this.web3.utils.toWei('999999999999')).send({
                ...this.contractsService.additionalParameters(),
                from: this.wallet
            }).then((result) => {
                console.log(result)
                if (result.events.Approval !== undefined) {
                    this.convertBNBtoKMON(amountToConvert, index)
                } else {
                    this.isSimplexLoading[index] = false;
                    this.toastService.genericError()
                }
            }).catch((err) => {
                this.isSimplexLoading[index] = false;
                this.toastService.genericError()
                console.log('allowance failed')
            });;
        }
    }

    allowanceRouter(value, index) {
        console.log(value)
        if (index == 1) {
            var contract = "contractInstanceV2";
        } else {
            var contract = "contractTokenInstance";
        }

        if (!value) {
            this.removeAllowances(contract, index);
        } else {
            this.setAllowances(contract, index)
        }

    }

    async checkAllAllowance() {
        let allowance = await this.contractsService.getContract(eContracts.KMON).methods.allowance(this.wallet, this.contractsService.getContractAddress(eContracts.MarketplaceProxy)).call();
        this.hasKmonAllowance = BigNumber.from(allowance).gt(0);
        console.log(this.hasKmonAllowance)
        this.hasNFTAllowance = await this.contractsService.getContract(eContracts.KMONFTV2).methods.isApprovedForAll(this.wallet, this.contractsService.getContractAddress(eContracts.MarketplaceProxy)).call();
        let biddingAllowance = await this.contractsService.getContract(eContracts.KMON).methods.allowance(this.wallet, this.contractsService.getContractAddress(eContracts.ERC721Bid)).call();
        this.hasBiddingAllowance = BigNumber.from(biddingAllowance).gt(0);
        let lootboxAllowance = await this.contractsService.getContract(eContracts.KMON).methods.allowance(this.wallet, this.contractsService.getContractAddress(eContracts.Lootbox)).call();
        this.hasLootboxesAllowance = BigNumber.from(lootboxAllowance).gt(0);
        let breedingAllowance = await this.contractsService.getContract(eContracts.KMON).methods.allowance(this.wallet, this.contractsService.getContractAddress(eContracts.KMONFTV2)).call();
        this.hasBreedingAllowance = BigNumber.from(breedingAllowance).gt(0);
    }

    async setAllowances(contract, index) {
        this.loadingAllowances[index] = true;
        if (contract == "contractTokenInstance") {
            if (index == 0) {
                var address = this.contractsService.getContractAddress(eContracts.MarketplaceProxy)
            } else if (index == 2) {
                var address = this.contractsService.getContractAddress(eContracts.ERC721Bid)
            } else if (index == 3) {
                var address = this.contractsService.getContractAddress(eContracts.Lootbox)
            } else if (index == 4) {
                var address = this.contractsService.getContractAddress(eContracts.KMONFTV2)
            }
            this.contractsService.getContract(eContracts.KMON).methods.approve(address, this.web3.utils.toWei('999999999999')).send({
                ...this.contractsService.additionalParameters(),
                from: this.wallet
            }).then((result) => {
                console.log(result)
                if (result.events.Approval !== undefined) {
                    this.checkAllAllowance().then(() => {
                        this.loadingAllowances[index] = false;
                    })
                } else {
                    this.toastService.genericError()
                }
            }).catch((err) => {
                this.toastService.genericError()
                console.log('allowance failed')
            });;
        } else {
            this.contractsService.getContract(eContracts.KMONFTV2).methods.setApprovalForAll(this.contractsService.getContractAddress(eContracts.MarketplaceProxy), true).send({
                ...this.contractsService.additionalParameters(),
                from: this.wallet
            }).then((result) => {
                console.log(result)
                if (result.events.ApprovalForAll !== undefined) {
                    this.checkAllAllowance().then(() => {
                        this.loadingAllowances[index] = false;
                    })
                } else {
                    this.toastService.genericError()
                }
            }).catch((err) => {
                this.toastService.genericError()
                console.log('allowance failed')
            });;
        }
    }

    async removeAllowances(contract, index) {
        this.loadingAllowances[index] = true;
        if (contract == "contractTokenInstance") {
            if (index == 0) {
                var address = this.contractsService.getContractAddress(eContracts.MarketplaceProxy)
            } else if (index == 2) {
                var address = this.contractsService.getContractAddress(eContracts.ERC721Bid)
            } else if (index == 3) {
                var address = this.contractsService.getContractAddress(eContracts.Lootbox)
            } else if (index == 4) {
                var address = this.contractsService.getContractAddress(eContracts.KMONFTV2)
            }
            this.contractsService.getContract(eContracts.KMON).methods.approve(address, this.web3.utils.toWei('0')).send({
                ...this.contractsService.additionalParameters(),
                from: this.wallet
            }).then((result) => {
                console.log(result)
                if (result.events.Approval !== undefined) {
                    this.checkAllAllowance().then(() => {
                        this.loadingAllowances[index] = false;
                    })
                } else {
                    this.toastService.genericError()
                }
            }).catch((err) => {
                this.toastService.genericError()
                console.log('allowance failed')
            });;
        } else {
            this.contractsService.getContract(eContracts.KMONFTV2).methods.setApprovalForAll(this.contractsService.getContractAddress(eContracts.MarketplaceProxy), false).send({
                ...this.contractsService.additionalParameters(),
                from: this.wallet
            }).then((result) => {
                console.log(result)
                if (result.events.ApprovalForAll !== undefined) {
                    this.checkAllAllowance().then(() => {
                        this.loadingAllowances[index] = false;
                    })
                } else {
                    this.toastService.genericError()
                }
            }).catch((err) => {
                this.toastService.genericError()
                console.log('allowance failed')
            });;
        }
    }

    getWalletTransactions() {
        this.walletTransactions = [];
        let post = { wallet: this.wallet }
        this.http.post(environment.apiBaseUrl + "bscscan/getWalletTxPolygon.php", post).subscribe((item: any) => {
            console.log(item)
            this.http.get(environment.coingecko + "api/v3/simple/price?ids=kryptomon,matic-network&vs_currencies=matic-network,usd&precision=18").subscribe((itemToken: any) => {
                for (let i = 0; i < item.length; i++) {
                    item[i].amountInt = this.web3.utils.fromWei(item[i].amount);
                    if (item[i].amountInt.length > 6) {
                        item[i].amount = (Math.round(item[i].amountInt * 100000) / 100000).toLocaleString()
                    } else {
                        item[i].amount = (item[i].amountInt).toLocaleString()
                    }


                    item[i].date = (new Date(item[i].timestamp * 1000)).toLocaleString().split(',')[0];
                    //item[i].timestamp = (new Date(item[i].timestamp*1000)).toLocaleString().split(',')[0];

                    if (item[i].currency == "KMON") {
                        item[i].usdValue = (Math.round(item[i].amountInt * itemToken.kryptomon.usd * 100000) / 100000).toLocaleString()
                    } else {
                        item[i].usdValue = (Math.round(item[i].amountInt * itemToken['matic-network'].usd * 100000) / 100000).toLocaleString()
                    }

                    if (item[i].type == 'In') {
                        item[i].amountFormatted = "+" + item[i].amount + " " + item[i].currency
                        item[i].usdFormatted = "+" + item[i].usdValue + " USD"
                        item[i].addressShown = "From: " + (item[i].from).slice(0, 5) + "..." + (item[i].from).slice(-4)
                    } else {
                        item[i].amountFormatted = "-" + item[i].amount + " " + item[i].currency
                        item[i].usdFormatted = "-" + item[i].usdValue + " USD"
                        item[i].addressShown = "To: " + (item[i].to).slice(0, 5) + "..." + (item[i].to).slice(-4)
                    }

                }

                this.walletTransactions = item.sort((a, b) => b.timestamp - a.timestamp)
            })

        })
    }

    exploreTx(hash) {
        window.open("https://polygonscan.com/tx/" + hash, "_blank")
    }

    openBridge(){
        window.open("https://portalbridge.com/advanced-tools/#/transfer?sourceChain=ethereum&targetChain=polygon", "_blank")
    }


    @HostListener('document:click', ['$event'])
    clickout(event) {
        if (this.eRef.nativeElement.contains(event.target)) {
            console.log("clicked inside");
        } else {
            console.log("clicked outside");
            if (this.showOnramper) this.closeOnramper();
        }
    }
}
